import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgePillComponent } from './badge-pill.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BadgePillComponent],
  exports: [BadgePillComponent],
})

export class BadgePillModule {
}
